import { Store, UPDATE, Action } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { debounceTime, switchMap, tap, take, map, filter } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import { AuthActionTypes } from '../../auth/state/auth.actions';
import * as AuthActions from '../../auth/state/auth.actions';
import { HydrateStoreAction, ClearFeatureStateAction } from '../state';

@Injectable()
export class AppEffects {

	private persistedStore: any = null;

	constructor(private actions$: Actions, private storage: Storage, private store: Store<any>) {

	}

	set$ = createEffect(() => {
        return this.actions$.pipe(
            debounceTime(500),
            switchMap(_ => this.store.pipe(take(1))),
            tap((store: any) =>	{
                console.debug('[AppEffects] Syncing local storage with current state', store);
                try {
                    this.storage.set('store', JSON.stringify(store))
                        .catch(err => console.warn('[AppEffects] Failed to persist store', err));
                } catch (err) {
                    console.warn('[AppEffects] Failed to persist store', err);
                }
            })
        )
    }, { dispatch: false });

	hydrate$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(AuthActionTypes.LoadStorageOk, UPDATE),
            tap((action: Action) => {
                if (action.type === AuthActionTypes.LoadStorageOk) {
                    this.persistedStore = (action as AuthActions.LoadStorageOkAction).store;
                }
            }),
            map(() => this.persistedStore),
            filter(store => !!store),
            map(store => HydrateStoreAction({ store }))
        )
    });

	clear$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(AuthActionTypes.Logout),
            tap(() => {
                this.persistedStore = null;
            }),
            map(() => ClearFeatureStateAction())
        )
    });
}
